/**
 * useListingInvalidationOnMutation — clears selection and invalidates the
 * listing query after a bulk mutation completes.
 *
 * A13 from listing-abstraction-opportunities.md
 *
 * Returns an onDataChanged callback suitable for mass-action modals plus a
 * success message string for the inline alert banner.
 */
import { useCallback, useState } from 'react';
export function useListingInvalidationOnMutation({ queryClient, queryKey, clearSelection }) {
    const [successMessage, setSuccessMessage] = useState('');
    const onDataChanged = useCallback((message) => {
        setSuccessMessage(message);
        clearSelection === null || clearSelection === void 0 ? void 0 : clearSelection();
        void queryClient.invalidateQueries({ queryKey });
    }, [queryClient, queryKey, clearSelection]);
    return { successMessage, setSuccessMessage, onDataChanged };
}
